// src/components/Appointment/Appointment.js

import React, { useState } from "react";
import "./Appointment.css";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";

function Appointment() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    location: "",
    service: "",
    date: "",
    slot: ""
  });

  const [loading, setLoading] = useState(false);

  /* DOCTOR SERVICES */
  const services = [
    "Skin Complaints",
    "Respiratory Issues",
    "Joint Complaints",
    "Endocrine Issues (PCOD, Thyroid, Diabetes, Obesity)",
    "Female Complaints (UTI, Dysmenorrhoea etc)",
    "Fertility Improvement",
    "Allergy Care",
    "Gut Disorders",
    "Paediatric Conditions",
    "Others"
  ];

  /* TIME SLOTS */
  const slots = [
    "09:00 AM",
    "09:30 AM",
    "10:00 AM",
    "10:30 AM",
    "11:00 AM",
    "11:30 AM",
    "12:00 PM",
    "12:30 PM",
    "02:00 PM",
    "02:30 PM",
    "03:00 PM",
    "03:30 PM",
    "04:00 PM",
    "04:30 PM",
    "05:00 PM",
    "05:30 PM",
    "06:00 PM",
    "06:30 PM",
    "07:00 PM",
    "07:30 PM",
    "08:00 PM"
  ];

  /* INPUT CHANGE */
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  /* SLOT SELECT */
  const selectSlot = (time) => {
    setFormData({
      ...formData,
      slot: time
    });
  };

  /* SUBMIT */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.slot) {
      Swal.fire({
        icon: "warning",
        title: "Please select time slot"
      });
      return;
    }

    try {
      setLoading(true);

      /* EMAIL TO USER */
      await emailjs.send(
        "service_5g8qfm1",
        "template_rvbkcbo",
        {
          user_name: formData.name,
          user_email: formData.email,
          appointment_date: formData.date,
          appointment_time: formData.slot,
          user_service: formData.service
        },
        "NHnP1MTlaemI0NU29"
      );

      /* SUCCESS POPUP */
      Swal.fire({
        icon: "success",
        title: "Appointment Booked with Rootly",
        text: "Thank you for booking with us.",
        confirmButtonColor: "#1F5B3A"
      });

      /* WHATSAPP TO CLINIC */
      const message =
`New Appointment Request

Name: ${formData.name}
Phone: ${formData.phone}
Email: ${formData.email}
Location: ${formData.location}
Service: ${formData.service}
Date: ${formData.date}
Time Slot: ${formData.slot}`;

      const whatsappURL =
        `https://wa.me/919391760160?text=${encodeURIComponent(message)}`;

      window.open(whatsappURL, "_blank");

      /* RESET */
      setFormData({
        name: "",
        phone: "",
        email: "",
        location: "",
        service: "",
        date: "",
        slot: ""
      });

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Something went wrong",
        text: "Please try again."
      });

      console.log(error);
    }

    setLoading(false);
  };

  return (
    <section className="appointment-section" id="appointment">

      <div className="appointment-container">

        {/* LEFT SIDE */}
        <div className="appointment-left">

          <p className="appoint-tag">
            BOOK NOW
          </p>

          <h2>
            Book An Appointment
          </h2>

          <form onSubmit={handleSubmit}>

            <input
              type="text"
              placeholder="Your Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="tel"
              placeholder="Phone Number"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              placeholder="Email Address"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              placeholder="Your Location"
              name="location"
              value={formData.location}
              onChange={handleChange}
              required
            />

            <select
              name="service"
              value={formData.service}
              onChange={handleChange}
              required
            >
              <option value="">
                Select Service
              </option>

              {services.map((item, index) => (
                <option
                  key={index}
                  value={item}
                >
                  {item}
                </option>
              ))}
            </select>

            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
            />

            {/* SLOT */}
            <div className="slot-section">

              <h4>Select Time Slot</h4>

              <div className="slots-grid">

                {slots.map((time, index) => (
                  <button
                    type="button"
                    key={index}
                    onClick={() => selectSlot(time)}
                    className={
                      formData.slot === time
                        ? "slot-btn active-slot"
                        : "slot-btn"
                    }
                  >
                    {time}
                  </button>
                ))}

              </div>

            </div>

            <button className="submit-btn">
              {loading ? "Booking..." : "Book Your Appointment"}
            </button>

          </form>

        </div>

        {/* RIGHT SIDE */}
        <div className="appointment-right">

          <div className="summary-card">

            <h3>Your Booking</h3>

            <p><strong>Name:</strong> {formData.name || "-"}</p>
            <p><strong>Phone:</strong> {formData.phone || "-"}</p>
            <p><strong>Email:</strong> {formData.email || "-"}</p>
            <p><strong>Location:</strong> {formData.location || "-"}</p>
            <p><strong>Service:</strong> {formData.service || "-"}</p>
            <p><strong>Date:</strong> {formData.date || "-"}</p>
            <p><strong>Slot:</strong> {formData.slot || "-"}</p>

          </div>

        </div>

      </div>

    </section>
  );
}

export default Appointment;